import {
  File,
  FilePdf,
  FileText,
  FolderSimple,
  Image,
} from "@phosphor-icons/react";

export const DD_FOLDER_NAME = "DD Project Planner";

export function fmtSize(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1073741824) return `${(bytes / 1048576).toFixed(1)} MB`;
  return `${(bytes / 1073741824).toFixed(1)} GB`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const date = new Date(iso);
  const diff = Math.floor((Date.now() - date) / 86400000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Yesterday";
  if (diff < 7) return `${diff} days ago`;
  if (diff < 30) return `${Math.floor(diff / 7)} week${diff >= 14 ? "s" : ""} ago`;
  return date.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
}

export function fileIcon(item) {
  if (item.folder) {
    if (item.name === "Completed Projects") return { Icon: FolderSimple, cls: "text-amber-500" };
    return { Icon: FolderSimple, cls: "text-[#0078D4]" };
  }
  const ext = item.name?.split(".").pop()?.toLowerCase() || "";
  if (ext === "pdf") return { Icon: FilePdf, cls: "text-red-500" };
  if (["png", "jpg", "jpeg", "gif", "bmp", "svg", "webp", "heic"].includes(ext)) return { Icon: Image, cls: "text-emerald-500" };
  if (["doc", "docx", "txt", "rtf"].includes(ext)) return { Icon: FileText, cls: "text-blue-500" };
  return { Icon: File, cls: "text-slate-400" };
}

const ANALYZABLE_EXTS = ["pdf", "png", "jpg", "jpeg", "webp", "bmp", "tiff", "tif"];

export function isAnalyzable(item) {
  if (item.folder) return false;
  const ext = item.name?.split(".").pop()?.toLowerCase() || "";
  return ANALYZABLE_EXTS.includes(ext);
}

const TOP_LEVEL_PROTECTED = new Set([
  "1. internal review dwg",
  "2. admin",
  "3. transmittal",
  "4. current working files",
  "pending review (drawings being processed)",
  "emails",
  "drawings",
]);

export function permissions(item, depth, parentName, completedOffset = 0) {
  if (!item.folder) {
    return { canRename: true, canDelete: true, canMove: true, canDownload: true, canOpen: true, badge: null };
  }
  if (depth === 0 && item.name === "Completed Projects") {
    return { canRename: false, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "system" };
  }
  const adjustedDepth = depth - completedOffset;
  if (adjustedDepth === 0) {
    return { canRename: true, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "project" };
  }
  if (adjustedDepth === 1) {
    const name = item.name?.toLowerCase();
    if (TOP_LEVEL_PROTECTED.has(name)) {
      return { canRename: false, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "protected" };
    }
  }
  if (adjustedDepth === 2) {
    const name = item.name?.toLowerCase();
    const parent = parentName?.toLowerCase();
    if ((parent === "emails" && name === "email attachments") || (parent === "drawings" && name === "previous versions")) {
      return { canRename: false, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "protected" };
    }
    if (parent === "3. transmittal") {
      return { canRename: false, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "protected" };
    }
  }
  if (adjustedDepth === 3) {
    const name = item.name?.toLowerCase();
    const parent = parentName?.toLowerCase();
    if (name === "drawings" && parent && /^2\.\d+/.test(parent)) {
      return { canRename: false, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "protected" };
    }
  }
  if (adjustedDepth === 4) {
    const name = item.name?.toLowerCase();
    const parent = parentName?.toLowerCase();
    if (name === "previous drawings" && parent === "drawings") {
      return { canRename: false, canDelete: false, canMove: false, canDownload: false, canOpen: true, badge: "protected" };
    }
  }
  return { canRename: true, canDelete: true, canMove: true, canDownload: false, canOpen: true, badge: null };
}
